/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * gringotts/v1/services/secret_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AccessSecretVersionParams,
  DeleteSecret200,
  DeleteSecret2200,
  DeleteSecret2Params,
  DeleteSecretParams,
  DiscoverInventory2Params,
  DiscoverInventoryParams,
  GetSecretParams,
  ListSecrets2Params,
  ListSecretsParams,
  RpcStatus,
  SecretServiceAddSecretVersionBodyBody,
  SecretServiceAdoptSecretBodyBody,
  SecretServiceCreateSecretBodyBody,
  SecretServiceUpdateSecretBodyBody,
  V1AccessSecretVersionResponse,
  V1AddSecretVersionResponse,
  V1DiscoverInventoryResponse,
  V1ListAllSecretsRequest,
  V1ListSecretsResponse,
  V1RefreshSecretRequest,
  V1Secret,
  V1ValidateSecretSchemaRequest,
  V1ValidateSecretSchemaResponse,
} from '../../models';

export const listSecrets = (
  organizationId: string,
  params?: ListSecretsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListSecretsResponse>> => {
  return axios.default.get(`/api/v1/organizations/${organizationId}/secrets`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListSecretsQueryKey = (
  organizationId?: string,
  params?: ListSecretsParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/secrets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSecretsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSecrets>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListSecretsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSecretsQueryKey(organizationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSecrets>>> = ({
    signal,
  }) => listSecrets(organizationId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSecrets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSecretsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSecrets>>
>;
export type ListSecretsQueryError = AxiosError<RpcStatus>;

export function useListSecrets<
  TData = Awaited<ReturnType<typeof listSecrets>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params: undefined | ListSecretsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecrets>>,
          TError,
          Awaited<ReturnType<typeof listSecrets>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecrets<
  TData = Awaited<ReturnType<typeof listSecrets>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListSecretsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecrets>>,
          TError,
          Awaited<ReturnType<typeof listSecrets>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecrets<
  TData = Awaited<ReturnType<typeof listSecrets>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListSecretsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListSecrets<
  TData = Awaited<ReturnType<typeof listSecrets>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListSecretsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSecretsQueryOptions(
    organizationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSecret = (
  organizationId: string,
  secretServiceCreateSecretBodyBody: SecretServiceCreateSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/secrets`,
    secretServiceCreateSecretBodyBody,
    options,
  );
};

export const getCreateSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSecret>>,
    TError,
    { organizationId: string; data: SecretServiceCreateSecretBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSecret>>,
  TError,
  { organizationId: string; data: SecretServiceCreateSecretBodyBody },
  TContext
> => {
  const mutationKey = ['createSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSecret>>,
    { organizationId: string; data: SecretServiceCreateSecretBodyBody }
  > = props => {
    const { organizationId, data } = props ?? {};

    return createSecret(organizationId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSecret>>
>;
export type CreateSecretMutationBody = SecretServiceCreateSecretBodyBody;
export type CreateSecretMutationError = AxiosError<RpcStatus>;

export const useCreateSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSecret>>,
      TError,
      { organizationId: string; data: SecretServiceCreateSecretBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSecret>>,
  TError,
  { organizationId: string; data: SecretServiceCreateSecretBodyBody },
  TContext
> => {
  const mutationOptions = getCreateSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getSecret = (
  organizationId: string,
  id: string,
  params?: GetSecretParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/secrets/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetSecretQueryKey = (
  organizationId?: string,
  id?: string,
  params?: GetSecretParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/secrets/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSecretQueryOptions = <
  TData = Awaited<ReturnType<typeof getSecret>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetSecretParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSecretQueryKey(organizationId, id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecret>>> = ({
    signal,
  }) => getSecret(organizationId, id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && id),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetSecretQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSecret>>
>;
export type GetSecretQueryError = AxiosError<RpcStatus>;

export function useGetSecret<
  TData = Awaited<ReturnType<typeof getSecret>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params: undefined | GetSecretParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecret>>,
          TError,
          Awaited<ReturnType<typeof getSecret>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecret<
  TData = Awaited<ReturnType<typeof getSecret>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetSecretParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecret>>,
          TError,
          Awaited<ReturnType<typeof getSecret>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecret<
  TData = Awaited<ReturnType<typeof getSecret>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetSecretParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSecret<
  TData = Awaited<ReturnType<typeof getSecret>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetSecretParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSecretQueryOptions(
    organizationId,
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteSecret = (
  organizationId: string,
  id: string,
  params?: DeleteSecretParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteSecret200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/secrets/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSecret>>,
    TError,
    { organizationId: string; id: string; params?: DeleteSecretParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSecret>>,
  TError,
  { organizationId: string; id: string; params?: DeleteSecretParams },
  TContext
> => {
  const mutationKey = ['deleteSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSecret>>,
    { organizationId: string; id: string; params?: DeleteSecretParams }
  > = props => {
    const { organizationId, id, params } = props ?? {};

    return deleteSecret(organizationId, id, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSecret>>
>;

export type DeleteSecretMutationError = AxiosError<RpcStatus>;

export const useDeleteSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSecret>>,
      TError,
      { organizationId: string; id: string; params?: DeleteSecretParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSecret>>,
  TError,
  { organizationId: string; id: string; params?: DeleteSecretParams },
  TContext
> => {
  const mutationOptions = getDeleteSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateSecret = (
  organizationId: string,
  id: string,
  secretServiceUpdateSecretBodyBody: SecretServiceUpdateSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organizationId}/secrets/${id}`,
    secretServiceUpdateSecretBodyBody,
    options,
  );
};

export const getUpdateSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSecret>>,
    TError,
    {
      organizationId: string;
      id: string;
      data: SecretServiceUpdateSecretBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSecret>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: SecretServiceUpdateSecretBodyBody;
  },
  TContext
> => {
  const mutationKey = ['updateSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSecret>>,
    {
      organizationId: string;
      id: string;
      data: SecretServiceUpdateSecretBodyBody;
    }
  > = props => {
    const { organizationId, id, data } = props ?? {};

    return updateSecret(organizationId, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSecret>>
>;
export type UpdateSecretMutationBody = SecretServiceUpdateSecretBodyBody;
export type UpdateSecretMutationError = AxiosError<RpcStatus>;

export const useUpdateSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSecret>>,
      TError,
      {
        organizationId: string;
        id: string;
        data: SecretServiceUpdateSecretBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSecret>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: SecretServiceUpdateSecretBodyBody;
  },
  TContext
> => {
  const mutationOptions = getUpdateSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const accessSecretVersion = (
  organizationId: string,
  id: string,
  version: number,
  params?: AccessSecretVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AccessSecretVersionResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/secrets/${id}/versions/${version}:access`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAccessSecretVersionQueryKey = (
  organizationId?: string,
  id?: string,
  version?: number,
  params?: AccessSecretVersionParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/secrets/${id}/versions/${version}:access`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAccessSecretVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof accessSecretVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  version: number,
  params?: AccessSecretVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccessSecretVersionQueryKey(organizationId, id, version, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accessSecretVersion>>
  > = ({ signal }) =>
    accessSecretVersion(organizationId, id, version, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && id && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accessSecretVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AccessSecretVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof accessSecretVersion>>
>;
export type AccessSecretVersionQueryError = AxiosError<RpcStatus>;

export function useAccessSecretVersion<
  TData = Awaited<ReturnType<typeof accessSecretVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  version: number,
  params: undefined | AccessSecretVersionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessSecretVersion>>,
          TError,
          Awaited<ReturnType<typeof accessSecretVersion>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAccessSecretVersion<
  TData = Awaited<ReturnType<typeof accessSecretVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  version: number,
  params?: AccessSecretVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessSecretVersion>>,
          TError,
          Awaited<ReturnType<typeof accessSecretVersion>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAccessSecretVersion<
  TData = Awaited<ReturnType<typeof accessSecretVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  version: number,
  params?: AccessSecretVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAccessSecretVersion<
  TData = Awaited<ReturnType<typeof accessSecretVersion>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  version: number,
  params?: AccessSecretVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAccessSecretVersionQueryOptions(
    organizationId,
    id,
    version,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addSecretVersion = (
  organizationId: string,
  id: string,
  secretServiceAddSecretVersionBodyBody: SecretServiceAddSecretVersionBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AddSecretVersionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/secrets/${id}:addVersion`,
    secretServiceAddSecretVersionBodyBody,
    options,
  );
};

export const getAddSecretVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSecretVersion>>,
    TError,
    {
      organizationId: string;
      id: string;
      data: SecretServiceAddSecretVersionBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSecretVersion>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: SecretServiceAddSecretVersionBodyBody;
  },
  TContext
> => {
  const mutationKey = ['addSecretVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSecretVersion>>,
    {
      organizationId: string;
      id: string;
      data: SecretServiceAddSecretVersionBodyBody;
    }
  > = props => {
    const { organizationId, id, data } = props ?? {};

    return addSecretVersion(organizationId, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSecretVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSecretVersion>>
>;
export type AddSecretVersionMutationBody =
  SecretServiceAddSecretVersionBodyBody;
export type AddSecretVersionMutationError = AxiosError<RpcStatus>;

export const useAddSecretVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addSecretVersion>>,
      TError,
      {
        organizationId: string;
        id: string;
        data: SecretServiceAddSecretVersionBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addSecretVersion>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: SecretServiceAddSecretVersionBodyBody;
  },
  TContext
> => {
  const mutationOptions = getAddSecretVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Wrap an existing backend entry as a GringottsSecret. No payload is
written; version 1 of the new secret references the existing storage.
 */
export const adoptSecret = (
  organizationId: string,
  secretServiceAdoptSecretBodyBody: SecretServiceAdoptSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/secrets:adopt`,
    secretServiceAdoptSecretBodyBody,
    options,
  );
};

export const getAdoptSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adoptSecret>>,
    TError,
    { organizationId: string; data: SecretServiceAdoptSecretBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adoptSecret>>,
  TError,
  { organizationId: string; data: SecretServiceAdoptSecretBodyBody },
  TContext
> => {
  const mutationKey = ['adoptSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adoptSecret>>,
    { organizationId: string; data: SecretServiceAdoptSecretBodyBody }
  > = props => {
    const { organizationId, data } = props ?? {};

    return adoptSecret(organizationId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdoptSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof adoptSecret>>
>;
export type AdoptSecretMutationBody = SecretServiceAdoptSecretBodyBody;
export type AdoptSecretMutationError = AxiosError<RpcStatus>;

/**
 * @summary Wrap an existing backend entry as a GringottsSecret. No payload is
written; version 1 of the new secret references the existing storage.
 */
export const useAdoptSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adoptSecret>>,
      TError,
      { organizationId: string; data: SecretServiceAdoptSecretBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adoptSecret>>,
  TError,
  { organizationId: string; data: SecretServiceAdoptSecretBodyBody },
  TContext
> => {
  const mutationOptions = getAdoptSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const listSecrets2 = (
  organizationId: string,
  workspaceId: string,
  params?: ListSecrets2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListSecretsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListSecrets2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: ListSecrets2Params,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSecrets2QueryOptions = <
  TData = Awaited<ReturnType<typeof listSecrets2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListSecrets2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSecrets2QueryKey(organizationId, workspaceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSecrets2>>> = ({
    signal,
  }) =>
    listSecrets2(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSecrets2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSecrets2QueryResult = NonNullable<
  Awaited<ReturnType<typeof listSecrets2>>
>;
export type ListSecrets2QueryError = AxiosError<RpcStatus>;

export function useListSecrets2<
  TData = Awaited<ReturnType<typeof listSecrets2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | ListSecrets2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecrets2>>,
          TError,
          Awaited<ReturnType<typeof listSecrets2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecrets2<
  TData = Awaited<ReturnType<typeof listSecrets2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListSecrets2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecrets2>>,
          TError,
          Awaited<ReturnType<typeof listSecrets2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSecrets2<
  TData = Awaited<ReturnType<typeof listSecrets2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListSecrets2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListSecrets2<
  TData = Awaited<ReturnType<typeof listSecrets2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListSecrets2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSecrets2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSecrets2QueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createSecret2 = (
  organizationId: string,
  workspaceId: string,
  secretServiceCreateSecretBodyBody: SecretServiceCreateSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets`,
    secretServiceCreateSecretBodyBody,
    options,
  );
};

export const getCreateSecret2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSecret2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: SecretServiceCreateSecretBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: SecretServiceCreateSecretBodyBody;
  },
  TContext
> => {
  const mutationKey = ['createSecret2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSecret2>>,
    {
      organizationId: string;
      workspaceId: string;
      data: SecretServiceCreateSecretBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return createSecret2(organizationId, workspaceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSecret2MutationResult = NonNullable<
  Awaited<ReturnType<typeof createSecret2>>
>;
export type CreateSecret2MutationBody = SecretServiceCreateSecretBodyBody;
export type CreateSecret2MutationError = AxiosError<RpcStatus>;

export const useCreateSecret2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSecret2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: SecretServiceCreateSecretBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: SecretServiceCreateSecretBodyBody;
  },
  TContext
> => {
  const mutationOptions = getCreateSecret2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getSecret2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}`,
    options,
  );
};

export const getGetSecret2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  id?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}`,
  ] as const;
};

export const getGetSecret2QueryOptions = <
  TData = Awaited<ReturnType<typeof getSecret2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSecret2QueryKey(organizationId, workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecret2>>> = ({
    signal,
  }) =>
    getSecret2(organizationId, workspaceId, id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && id),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSecret2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSecret2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getSecret2>>
>;
export type GetSecret2QueryError = AxiosError<RpcStatus>;

export function useGetSecret2<
  TData = Awaited<ReturnType<typeof getSecret2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecret2>>,
          TError,
          Awaited<ReturnType<typeof getSecret2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecret2<
  TData = Awaited<ReturnType<typeof getSecret2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecret2>>,
          TError,
          Awaited<ReturnType<typeof getSecret2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSecret2<
  TData = Awaited<ReturnType<typeof getSecret2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSecret2<
  TData = Awaited<ReturnType<typeof getSecret2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSecret2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSecret2QueryOptions(
    organizationId,
    workspaceId,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteSecret2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  params?: DeleteSecret2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteSecret2200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteSecret2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSecret2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      params?: DeleteSecret2Params;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    params?: DeleteSecret2Params;
  },
  TContext
> => {
  const mutationKey = ['deleteSecret2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSecret2>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      params?: DeleteSecret2Params;
    }
  > = props => {
    const { organizationId, workspaceId, id, params } = props ?? {};

    return deleteSecret2(organizationId, workspaceId, id, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSecret2MutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSecret2>>
>;

export type DeleteSecret2MutationError = AxiosError<RpcStatus>;

export const useDeleteSecret2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSecret2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        params?: DeleteSecret2Params;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    params?: DeleteSecret2Params;
  },
  TContext
> => {
  const mutationOptions = getDeleteSecret2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateSecret2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  secretServiceUpdateSecretBodyBody: SecretServiceUpdateSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}`,
    secretServiceUpdateSecretBodyBody,
    options,
  );
};

export const getUpdateSecret2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSecret2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: SecretServiceUpdateSecretBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: SecretServiceUpdateSecretBodyBody;
  },
  TContext
> => {
  const mutationKey = ['updateSecret2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSecret2>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: SecretServiceUpdateSecretBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, id, data } = props ?? {};

    return updateSecret2(organizationId, workspaceId, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSecret2MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSecret2>>
>;
export type UpdateSecret2MutationBody = SecretServiceUpdateSecretBodyBody;
export type UpdateSecret2MutationError = AxiosError<RpcStatus>;

export const useUpdateSecret2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSecret2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        data: SecretServiceUpdateSecretBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: SecretServiceUpdateSecretBodyBody;
  },
  TContext
> => {
  const mutationOptions = getUpdateSecret2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const accessSecretVersion2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AccessSecretVersionResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}/versions/${version}:access`,
    options,
  );
};

export const getAccessSecretVersion2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  id?: string,
  version?: number,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}/versions/${version}:access`,
  ] as const;
};

export const getAccessSecretVersion2QueryOptions = <
  TData = Awaited<ReturnType<typeof accessSecretVersion2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccessSecretVersion2QueryKey(organizationId, workspaceId, id, version);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accessSecretVersion2>>
  > = ({ signal }) =>
    accessSecretVersion2(organizationId, workspaceId, id, version, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && id && version),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accessSecretVersion2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AccessSecretVersion2QueryResult = NonNullable<
  Awaited<ReturnType<typeof accessSecretVersion2>>
>;
export type AccessSecretVersion2QueryError = AxiosError<RpcStatus>;

export function useAccessSecretVersion2<
  TData = Awaited<ReturnType<typeof accessSecretVersion2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessSecretVersion2>>,
          TError,
          Awaited<ReturnType<typeof accessSecretVersion2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAccessSecretVersion2<
  TData = Awaited<ReturnType<typeof accessSecretVersion2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessSecretVersion2>>,
          TError,
          Awaited<ReturnType<typeof accessSecretVersion2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAccessSecretVersion2<
  TData = Awaited<ReturnType<typeof accessSecretVersion2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAccessSecretVersion2<
  TData = Awaited<ReturnType<typeof accessSecretVersion2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accessSecretVersion2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAccessSecretVersion2QueryOptions(
    organizationId,
    workspaceId,
    id,
    version,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addSecretVersion2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  secretServiceAddSecretVersionBodyBody: SecretServiceAddSecretVersionBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AddSecretVersionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets/${id}:addVersion`,
    secretServiceAddSecretVersionBodyBody,
    options,
  );
};

export const getAddSecretVersion2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSecretVersion2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: SecretServiceAddSecretVersionBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSecretVersion2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: SecretServiceAddSecretVersionBodyBody;
  },
  TContext
> => {
  const mutationKey = ['addSecretVersion2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSecretVersion2>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: SecretServiceAddSecretVersionBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, id, data } = props ?? {};

    return addSecretVersion2(
      organizationId,
      workspaceId,
      id,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSecretVersion2MutationResult = NonNullable<
  Awaited<ReturnType<typeof addSecretVersion2>>
>;
export type AddSecretVersion2MutationBody =
  SecretServiceAddSecretVersionBodyBody;
export type AddSecretVersion2MutationError = AxiosError<RpcStatus>;

export const useAddSecretVersion2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addSecretVersion2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        data: SecretServiceAddSecretVersionBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addSecretVersion2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: SecretServiceAddSecretVersionBodyBody;
  },
  TContext
> => {
  const mutationOptions = getAddSecretVersion2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Wrap an existing backend entry as a GringottsSecret. No payload is
written; version 1 of the new secret references the existing storage.
 */
export const adoptSecret2 = (
  organizationId: string,
  workspaceId: string,
  secretServiceAdoptSecretBodyBody: SecretServiceAdoptSecretBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/secrets:adopt`,
    secretServiceAdoptSecretBodyBody,
    options,
  );
};

export const getAdoptSecret2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adoptSecret2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: SecretServiceAdoptSecretBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adoptSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: SecretServiceAdoptSecretBodyBody;
  },
  TContext
> => {
  const mutationKey = ['adoptSecret2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adoptSecret2>>,
    {
      organizationId: string;
      workspaceId: string;
      data: SecretServiceAdoptSecretBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return adoptSecret2(organizationId, workspaceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdoptSecret2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adoptSecret2>>
>;
export type AdoptSecret2MutationBody = SecretServiceAdoptSecretBodyBody;
export type AdoptSecret2MutationError = AxiosError<RpcStatus>;

/**
 * @summary Wrap an existing backend entry as a GringottsSecret. No payload is
written; version 1 of the new secret references the existing storage.
 */
export const useAdoptSecret2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adoptSecret2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: SecretServiceAdoptSecretBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adoptSecret2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: SecretServiceAdoptSecretBodyBody;
  },
  TContext
> => {
  const mutationOptions = getAdoptSecret2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Enumerate raw entries in the backend that serves a given scope,
whether or not Gringotts created them. Used by clients to power a
"pick existing entry" UI on the create-secret flow.
 */
export const discoverInventory2 = (
  organizationId: string,
  workspaceId: string,
  params?: DiscoverInventory2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiscoverInventoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}:discoverInventory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDiscoverInventory2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: DiscoverInventory2Params,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}:discoverInventory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDiscoverInventory2QueryOptions = <
  TData = Awaited<ReturnType<typeof discoverInventory2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: DiscoverInventory2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDiscoverInventory2QueryKey(organizationId, workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof discoverInventory2>>
  > = ({ signal }) =>
    discoverInventory2(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof discoverInventory2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DiscoverInventory2QueryResult = NonNullable<
  Awaited<ReturnType<typeof discoverInventory2>>
>;
export type DiscoverInventory2QueryError = AxiosError<RpcStatus>;

export function useDiscoverInventory2<
  TData = Awaited<ReturnType<typeof discoverInventory2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | DiscoverInventory2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverInventory2>>,
          TError,
          Awaited<ReturnType<typeof discoverInventory2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscoverInventory2<
  TData = Awaited<ReturnType<typeof discoverInventory2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: DiscoverInventory2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverInventory2>>,
          TError,
          Awaited<ReturnType<typeof discoverInventory2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscoverInventory2<
  TData = Awaited<ReturnType<typeof discoverInventory2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: DiscoverInventory2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Enumerate raw entries in the backend that serves a given scope,
whether or not Gringotts created them. Used by clients to power a
"pick existing entry" UI on the create-secret flow.
 */

export function useDiscoverInventory2<
  TData = Awaited<ReturnType<typeof discoverInventory2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: DiscoverInventory2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDiscoverInventory2QueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Enumerate raw entries in the backend that serves a given scope,
whether or not Gringotts created them. Used by clients to power a
"pick existing entry" UI on the create-secret flow.
 */
export const discoverInventory = (
  organizationId: string,
  params?: DiscoverInventoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiscoverInventoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}:discoverInventory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDiscoverInventoryQueryKey = (
  organizationId?: string,
  params?: DiscoverInventoryParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}:discoverInventory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDiscoverInventoryQueryOptions = <
  TData = Awaited<ReturnType<typeof discoverInventory>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: DiscoverInventoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDiscoverInventoryQueryKey(organizationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof discoverInventory>>
  > = ({ signal }) =>
    discoverInventory(organizationId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof discoverInventory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DiscoverInventoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof discoverInventory>>
>;
export type DiscoverInventoryQueryError = AxiosError<RpcStatus>;

export function useDiscoverInventory<
  TData = Awaited<ReturnType<typeof discoverInventory>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params: undefined | DiscoverInventoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverInventory>>,
          TError,
          Awaited<ReturnType<typeof discoverInventory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscoverInventory<
  TData = Awaited<ReturnType<typeof discoverInventory>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: DiscoverInventoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverInventory>>,
          TError,
          Awaited<ReturnType<typeof discoverInventory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDiscoverInventory<
  TData = Awaited<ReturnType<typeof discoverInventory>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: DiscoverInventoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Enumerate raw entries in the backend that serves a given scope,
whether or not Gringotts created them. Used by clients to power a
"pick existing entry" UI on the create-secret flow.
 */

export function useDiscoverInventory<
  TData = Awaited<ReturnType<typeof discoverInventory>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: DiscoverInventoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof discoverInventory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDiscoverInventoryQueryOptions(
    organizationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Validate a typed payload against a schema. Pure check — no stored
secret is read, no payload is persisted. Returns `valid = false` plus
per-field violations on mismatch; never an `INVALID_ARGUMENT` status.
 */
export const validateSecretSchema = (
  v1ValidateSecretSchemaRequest: V1ValidateSecretSchemaRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateSecretSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/secretTypes:validateSchema`,
    v1ValidateSecretSchemaRequest,
    options,
  );
};

export const getValidateSecretSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateSecretSchema>>,
    TError,
    { data: V1ValidateSecretSchemaRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateSecretSchema>>,
  TError,
  { data: V1ValidateSecretSchemaRequest },
  TContext
> => {
  const mutationKey = ['validateSecretSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateSecretSchema>>,
    { data: V1ValidateSecretSchemaRequest }
  > = props => {
    const { data } = props ?? {};

    return validateSecretSchema(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateSecretSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateSecretSchema>>
>;
export type ValidateSecretSchemaMutationBody = V1ValidateSecretSchemaRequest;
export type ValidateSecretSchemaMutationError = AxiosError<RpcStatus>;

/**
 * @summary Validate a typed payload against a schema. Pure check — no stored
secret is read, no payload is persisted. Returns `valid = false` plus
per-field violations on mismatch; never an `INVALID_ARGUMENT` status.
 */
export const useValidateSecretSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateSecretSchema>>,
      TError,
      { data: V1ValidateSecretSchemaRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateSecretSchema>>,
  TError,
  { data: V1ValidateSecretSchemaRequest },
  TContext
> => {
  const mutationOptions = getValidateSecretSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const listAllSecrets = (
  v1ListAllSecretsRequest: V1ListAllSecretsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListSecretsResponse>> => {
  return axios.default.post(
    `/kognitos.gringotts.v1.SecretService/ListAllSecrets`,
    v1ListAllSecretsRequest,
    options,
  );
};

export const getListAllSecretsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listAllSecrets>>,
    TError,
    { data: V1ListAllSecretsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listAllSecrets>>,
  TError,
  { data: V1ListAllSecretsRequest },
  TContext
> => {
  const mutationKey = ['listAllSecrets'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listAllSecrets>>,
    { data: V1ListAllSecretsRequest }
  > = props => {
    const { data } = props ?? {};

    return listAllSecrets(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListAllSecretsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listAllSecrets>>
>;
export type ListAllSecretsMutationBody = V1ListAllSecretsRequest;
export type ListAllSecretsMutationError = AxiosError<RpcStatus>;

export const useListAllSecrets = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listAllSecrets>>,
      TError,
      { data: V1ListAllSecretsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listAllSecrets>>,
  TError,
  { data: V1ListAllSecretsRequest },
  TContext
> => {
  const mutationOptions = getListAllSecretsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Renew an OAuth connection's access token. Overwrites the stored value and
re-points the single version at it — no new version is added. Always
refreshes; which connections are due is the caller's decision.
 */
export const refreshSecret = (
  v1RefreshSecretRequest: V1RefreshSecretRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Secret>> => {
  return axios.default.post(
    `/kognitos.gringotts.v1.SecretService/RefreshSecret`,
    v1RefreshSecretRequest,
    options,
  );
};

export const getRefreshSecretMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSecret>>,
    TError,
    { data: V1RefreshSecretRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshSecret>>,
  TError,
  { data: V1RefreshSecretRequest },
  TContext
> => {
  const mutationKey = ['refreshSecret'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshSecret>>,
    { data: V1RefreshSecretRequest }
  > = props => {
    const { data } = props ?? {};

    return refreshSecret(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshSecret>>
>;
export type RefreshSecretMutationBody = V1RefreshSecretRequest;
export type RefreshSecretMutationError = AxiosError<RpcStatus>;

/**
 * @summary Renew an OAuth connection's access token. Overwrites the stored value and
re-points the single version at it — no new version is added. Always
refreshes; which connections are due is the caller's decision.
 */
export const useRefreshSecret = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshSecret>>,
      TError,
      { data: V1RefreshSecretRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshSecret>>,
  TError,
  { data: V1RefreshSecretRequest },
  TContext
> => {
  const mutationOptions = getRefreshSecretMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
